import { combineReducers } from 'redux';
import {
  FETCH_ALL,
  FETCH_ALL_SUCCESS,
  FETCH_ONE_SUCCESS,
  UPDATE_SUCCESS,
  DELETE,
  DELETE_SUCCESS,
  DELETE_FAILURE,
  CREATE,
  CREATE_SUCCESS,
  CREATE_FAILURE,
  FETCH_ALL_FAILURE,
  FETCH_ONE,
  FETCH_ONE_FAILURE,
  UPDATE,
  UPDATE_FAILURE,
} from './constants';

const reviewCollectionInitialState = {
  data: {
    current_page: 1,
    per_page: 20,
    total: 20,
    data: [],
  },
  requests: {},
  fetching: {},
  error: '',
  actionReview: {
    review: '',
    author: '',
    location: '',
  },
};

const reviewCollectionReducer = (state = reviewCollectionInitialState, action) => {
  switch (action.type) {
    case FETCH_ALL:
      console.log(FETCH_ALL);
      return {
        ...state,
        requests: { ...state.requests },
        fetching: { ...state.fetching },
        error: '',
      };
    case FETCH_ALL_SUCCESS: {
      console.log(FETCH_ALL_SUCCESS);
      return {
        ...state,
        data: action.data,
        fetching: { ...state.fetching },
      };
    }
    case FETCH_ALL_FAILURE:
      return {
        ...state,
        fetching: { ...state.fetching },
        error: action.error,
      };

    case FETCH_ONE:
      return { ...state, fetching: { ...state.fetching } };
    case FETCH_ONE_SUCCESS:
      return {
        ...state,
        actionReview: {
          ...action.data,
          review: action.data.review,
          author: action.data.author,
          location: action.data.location,
        },
      };
    case FETCH_ONE_FAILURE:
      return { ...state, error: action.error };

    case CREATE:
      return { ...state };
    case CREATE_SUCCESS:
      return {
        ...state,
        actionReview: reviewCollectionInitialState.actionReview,
        data: { ...state.data, data: [...state.data.data, action.data] },
      };
    case CREATE_FAILURE:
      return { ...state, error: action.error };

    case DELETE: {
      return { ...state };
    }
    case DELETE_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          data: state.data.data.filter(s => s.id !== action.data.id),
        },
      };
    }
    case DELETE_FAILURE:
      return { ...state, error: action.error };

    case UPDATE:
      return { ...state };
    case UPDATE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          data: state.data.data.map(s => (s.id === action.data.id ? action.data : s)),
        },
      };
    case UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

export default combineReducers({
  reviewCollection: reviewCollectionReducer,
});
